// extracted by mini-css-extract-plugin
module.exports = {"footer":"sticky-foot_footer__TsqWJ","textUppercase":"sticky-foot_textUppercase__i9PB1"};